
/* injects from baggage-loader */

'use strict';

export default class CheckMailingInstructionsModalController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		
		// Set modal context
		if (this.resolve) {
			this.escrow_provider = this.resolve.escrow_provider;
			this.amount = this.resolve.amount;
			this.project = this.resolve.project;
			if (this.escrow_provider === 'prime_trust') {
				this.instructions = this.resolve.instructions;
			}
		}

	}

	isNorthCapitalInvestment() {
		return this.escrow_provider === 'north_capital';
	}

	isPrimeTrustInvestment() {
		return this.escrow_provider === 'prime_trust';
	}

	close() {
		this.dismiss({ $value: 'cancel' });
	}

}
